import React, { useEffect, useState, useRef } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { IconButton, Typography } from '@material-ui/core';
import { AddCircle as AddIcon } from '@material-ui/icons';
import Dialog from 'common/components/Dialog';
import DocumentNotificationDialogDistributionList from './DocumentNotificationDialogDistributionList';

const EMPTY_DIST_LIST = {
  departments: [],
  recipients: [],
  isEnabled: true,
};

const styles = theme => ({
  paper: {
    width: 600,
    height: 600,
  },
  addBtnContainer: {
    width: '100%',
    textAlign: 'center',
  },
  addBtnIcon: {
    color: theme.palette.secondary.main,
    width: 40,
    height: 40,
  },
  closeBtn: {
    background: '#f4f6f8',
    color: 'black',
  },
  saveBtn: {
    background: '#45a7dc',
    color: 'white',
  },
});

const DocumentNotificationDialog = props => {
  const {
    classes,
    distributionLists: upstreamDistLists = [],
    notificationName,
    onClose,
    onSave,
    open,
  } = props;
  const initialDistLists = upstreamDistLists.length
    ? upstreamDistLists
    : [EMPTY_DIST_LIST];

  const [distLists, setDistLists] = useState(initialDistLists);
  const [shouldScrollToEnd, setShouldScrollToEnd] = useState(false);
  const addBtnContainerRef = useRef();

  useEffect(() => {
    if (!shouldScrollToEnd) return;
    addBtnContainerRef.current.scrollIntoView({ behavior: 'smooth' });
    setShouldScrollToEnd(false);
  }, [shouldScrollToEnd]);

  const addDistList = () => {
    setDistLists(distLists.concat(EMPTY_DIST_LIST));
    setShouldScrollToEnd(true);
  };

  const save = () => onSave(distLists).then(onClose);

  const distListsList = distLists.map((distList, index) => {
    const isMultiple = distLists.length > 1;

    const replaceDistList = newDistList => {
      const newDistLists = distLists.map((distList, i) =>
        i === index ? newDistList : distList,
      );
      setDistLists(newDistLists);
    };

    const deleteDistList = () =>
      setDistLists(distLists.filter((__, i) => i !== index));

    return (
      <span
        data-test-id={`DocumentNotificationDialog-distributionList-${index}`}
        key={index}
      >
        <DocumentNotificationDialogDistributionList
          distributionList={distList}
          onChange={replaceDistList}
          onDelete={isMultiple && deleteDistList}
        />
      </span>
    );
  });

  const body = (
    <div>
      <Typography variant="subtitle1">
        Configure recipient lists for these notifications here. Lists with
        associated departments will only be notified of offers for jobs in that
        department. Lists without a department will receive all notifications.
      </Typography>
      {distListsList}
      <div className={classes.addBtnContainer} ref={addBtnContainerRef}>
        <IconButton
          onClick={addDistList}
          data-test-id="DocumentNotificationDialog-addDistributionList"
        >
          <AddIcon className={classes.addBtnIcon} />
        </IconButton>
      </div>
    </div>
  );

  return (
    <Dialog
      classes={{ paper: classes.paper }}
      open={open}
      title={notificationName}
      message={body}
      actions={[
        { text: 'Cancel', fn: onClose, className: classes.closeBtn },
        { text: 'Save', fn: save, className: classes.saveBtn },
      ]}
      handleClose={onClose}
    />
  );
};

export default withStyles(styles)(DocumentNotificationDialog);
